import "./track_select.css";
import React, { useEffect } from "react";

interface TrackSelectProps {
  activeTracks?: any[];
  setActiveTracks: (tabs: any[]) => void;
}

const trackOptions = [
  { value: "1", label: "Çim" },
  { value: "2", label: "Kum" },
  { value: "4", label: "Sentetik" },
];

const TrackSelect: React.FC<TrackSelectProps> = ({ activeTracks = [], setActiveTracks }) => {
  useEffect(() => {
    if (activeTracks.length === 0) {
      setActiveTracks(trackOptions);
    }
  }, [setActiveTracks, activeTracks]);

  const handleSelect = (track: any) => {
    if (activeTracks.some((selected) => selected.value === track.value)) {
      setActiveTracks(activeTracks.filter((selected) => selected.value !== track.value));
    } else {
      setActiveTracks([...activeTracks, track]);
    }
  };

  return (
    <div className="tracks">
      <label>PİST TÜRÜ : </label>
      {trackOptions.map((track: any) => (
        <div className="track-item" key={track.value}>
          <a
            className={`track-link ${activeTracks.some((selected) => selected.value === track.value) ? "active" : ""}`}
            onClick={() => handleSelect(track)}
            href="#!"
          >
            {track.label}
          </a>
        </div>
      ))}
    </div>
  );
};

export default TrackSelect;
